import { gsap } from "gsap";
import { MotionPathPlugin } from "gsap/MotionPathPlugin";

gsap.registerPlugin(MotionPathPlugin);

gsap.config({
  force3D: false,
  nullTargetWarn: false,
});

gsap.defaults({
  ease: "power1.out",
});

export const preAnimate = () => {
  setDefaults();
  const master = gsap.timeline();
  master.add(
    showElements([
      ".emerge-robot-full",
      ".emerge-robot",
      ".emerge-portal",
      ".emerge .challenge .hero__content",
      ".emerge .challenge .animation-btn",
    ])
  );
  return master;
};

function setDefaults() {
  gsap.set(".emerge-glasses", {
    y: 280,
    x: 110,
    rotate: -65,
    transformOrigin: "50% 50%",
  });
  gsap.set(".emerge-body-1", { autoAlpha: 1 });
  gsap.set(".emerge-body-2", { autoAlpha: 0 });
  gsap.set(".emerge-cloud", { y: 70, autoAlpha: 0 });
  gsap.set(".emerge-anim", { x: 800 });
  gsap.set(".emerge-robot", { y: 230 });
  gsap.set(".emerge-hand", { transformOrigin: "100% 0%" });
  gsap.set(".emerge-robot-mask", { y: 230 });
  gsap.set(".emerge-portal", {
    scaleX: 0,
    scaleY: 0,
    transformOrigin: "82% 50%",
  });
  gsap.set(".emerge-portal-top", { y: 5 });
  gsap.set(".emerge-portal-bottom", { y: -5 });
}

export const afterAnimate = () => {
  gsap.set(".emerge-glasses", { y: 0, x: 0, rotate: 0 });
  gsap.set(".emerge-body-1", { autoAlpha: 0 });
  gsap.set(".emerge-body-2", { autoAlpha: 1 });
  gsap.set(".emerge-cloud", { y: 0, autoAlpha: 1 });
  gsap.set(".emerge-anim", { x: 0 });
  gsap.set(".emerge-robot", { y: 0 });
  gsap.set(".emerge-robot-mask", { y: 230 });
  gsap.set(".emerge-portal", {
    scaleX: 1,
    scaleY: 1,
    transformOrigin: "82% 50%",
  });
  gsap.set(".emerge-portal-top", { y: 0 });
  gsap.set(".emerge-portal-bottom", { y: 0 });
  gsap.set(".emerge .challenge__content", {
    autoAlpha: 1,
    visibility: "visible",
    y: 0,
  });
};

const master = gsap.timeline({
  paused: true,
});
export const animation = (setIsFinished) => {
  master

    .add(robotPortalOpenAnimation(".emerge-portal"), 0.5)
    .add(robotAnimation(".emerge-robot"))
    .add(robotPortalCloseAnimation(".emerge-portal"))
    .add(robotHand(".emerge-hand"))
    .add(
      moveGlasses(".emerge-glasses", [
        {
          y: 280,
          x: 110,
        },
        {
          y: 50,
          x: 50,
        },
        {
          y: 0,
          x: 0,
        },
      ]),
      "<"
    )
    .add(hideContent(".emerge .challenge .hero__content"), 3.5)
    .add(moveToStart(".emerge-anim", 1), "<")
    .add(showContent(".emerge-cloud"))
    .add(showContent(".emerge-body-2"), "<")
    .add(hideElements(".emerge-body-1"), "<")
    .add(showContent(".emerge .challenge .challenge__content"), "<")
    .to(".emerge .challenge .animation-btn", {
      autoAlpha: 0,
      opacity: 0,
      duration: 0.2,
      onComplete: () => {
        setIsFinished(true);
      },
    });
  return master;
};

function showElements(selectors, duration = 0) {
  const tl = gsap.timeline();
  tl.to(selectors, { autoAlpha: 1, opacity: 1, duration });
  return tl;
}
function hideElements(selectors, duration = 0.5) {
  const tl = gsap.timeline();
  tl.to(selectors, { autoAlpha: 0, opacity: 0, duration });
  return tl;
}

function moveToStart(selector, duration = 1) {
  const tl = gsap.timeline();
  tl.to(selector, { x: 0, y: 0, scale: 1, duration: duration });
  return tl;
}

function moveGlasses(selector, path, duration = 0.75) {
  const tl = gsap.timeline();
  tl.to(selector, {
    rotate: 0,
    duration,
    motionPath: path,
  });
  return tl;
}

function robotPortalOpenAnimation(selector) {
  const tl = gsap.timeline();
  tl.to(selector, { scaleX: 2.15, scaleY: 1, y: 0, duration: 0.5 });
  return tl;
}

function robotPortalCloseAnimation(selector) {
  const tl = gsap.timeline();
  tl.to(selector, {
    scaleX: 1,
    scaleY: 1,
    duration: 0.3,
  });
  return tl;
}

function robotAnimation(selector) {
  const tl = gsap.timeline();
  tl.to(selector, { y: 0, duration: 1 });
  return tl;
}

function robotHand(selector) {
  const tl = gsap.timeline();
  tl.to(selector, { rotate: 10, duration: 0.2 }).to(selector, {
    rotate: 0,
    duration: 0.2,
  });
  return tl;
}

function hideContent(selector) {
  const tl = gsap.timeline();
  tl.to(selector, { autoAlpha: 0, opacity: 0, yPercent: -50, duration: 0.5 });
  return tl;
}

function showContent(selector) {
  const tl = gsap.timeline();
  tl.to(selector, { autoAlpha: 1, opacity: 1, y: 0, duration: 0.5 });
  return tl;
}
